import { useCallback, useEffect, useState, Fragment } from "react";
import useHttp from "hooks/use-http";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { BiSupport } from "react-icons/bi";
import { BsFillTelephoneFill, BsTelegram } from "react-icons/bs";
import { RiWhatsappFill, RiInstagramFill } from "react-icons/ri";
import { getStatusRequest } from "api/requests";
import { StyledSpeedDial, StyledLinkcart, StyledButton } from "./Contact.style";
import Toast from "helper/toast";
import useAuth from "hooks/use-auth";
import { Badge } from "@mui/material";

function ContactCM(props) {
  const { request } = useHttp();
  const AuthCTX = useAuth();
  const [ticketCount, setTicketCount] = useState(0);

  const getStatus = useCallback(async () => {
    const res = await request({
      url: getStatusRequest,
    });
    setTicketCount(res.new_tickets_count);
  }, [request]);

  useEffect(() => {
    if (AuthCTX.isLoggedIn) {
      getStatus();
    }
  }, []);

  // const handleLoginCheck = async (event) => {
  //   return Toast({
  //     type: "custom-warn",
  //     title: "برای پشتیبانی وارد حساب کاربری خود شوید",
  //   });
  // };

  return (
    <Fragment>
      {!AuthCTX.isLoggedIn ? (
        <>
          {/* <StyledButton onClick={handleLoginCheck}>
            <BiSupport size={30} />
          </StyledButton> */}
          <StyledLinkcart to={"/ticket"}>
            <BiSupport size={30} />
          </StyledLinkcart>
        </>
      ) : (
        <>
          {props.Furniture && (
            <>
              {ticketCount !== "0" ? (
                <StyledLinkcart to={"/ticket"}>
                  <Badge
                    color="warning"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    badgeContent={ticketCount}
                  >
                    <BiSupport size={30} />
                  </Badge>
                </StyledLinkcart>
              ) : (
                <StyledLinkcart to={"/ticket"}>
                  <BiSupport size={30} />
                </StyledLinkcart>
              )}
            </>
          )}

          {props.Accessory && (
            <>
              {ticketCount !== "0" ? (
                <StyledLinkcart to={"/ticket"}>
                  <Badge
                    color="warning"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    badgeContent={ticketCount}
                  >
                    <BiSupport size={30} />
                  </Badge>
                </StyledLinkcart>
              ) : (
                <StyledLinkcart to={"/ticket"}>
                  <BiSupport size={30} />
                </StyledLinkcart>
              )}
            </>
          )}

          {props.All && (
            <>
              {ticketCount !== "0" ? (
                <StyledLinkcart to={"/ticket"}>
                  <Badge
                    color="warning"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    badgeContent={ticketCount}
                  >
                    <BiSupport size={30} />
                  </Badge>
                </StyledLinkcart>
              ) : (
                <StyledLinkcart to={"/ticket"}>
                  <BiSupport size={30} />
                </StyledLinkcart>
              )}
            </>
          )}
        </>
      )}
    </Fragment>
  );
}

export default ContactCM;
